/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosCollapseComponent from "../../CollapseComponent/ArgosCollapseComponent"
import ArgosFlexbox from "../../Containers/ArgosFlexbox"
import {theme} from "../../../../constants/theme"
import {useEffect, useState} from "react"


interface IFullReportProps {
  componentDataMap: any
}

/**
 * Renders the FullReport view for the selected report.
 * Collapse sections are rendered dynamically based on the report's contents and format.
 */
const FullReport = (props: IFullReportProps) => {
  const [componentDataMap, setComponentsDataMap] = useState<any>({})

  useEffect(() => {
    setComponentsDataMap(props?.componentDataMap)
  }, [props])

  return(
    <ArgosFlexbox style={{flex: 1, overflow: 'auto'}}>
      <ArgosCollapseComponent
        styleProps={{
          outlineOnly: true,
          fontColor: theme.layout.sidebar.backgroundColor,
        }}
        data={componentDataMap ?? {}}
        openTabIndex={1}
        disableResultsText={false}
      />
    </ArgosFlexbox>
  )
}

export default FullReport
